import './JTBDMatter.scss';

const jtbdSection = {
  title: 'Porque é Importante?',
  subtitle: (
    <>
      Compreender o verdadeiro <em>trabalho a ser feito</em> permite-lhe alinhar os seus produtos ou serviços com o que os seus clientes realmente procuram.
      Em vez de adivinhar, passa a oferecer soluções com propósito, que criam mais valor, destacam-se no mercado e comunicam com clareza.
    </>
  ),
};

const benefitsData = [
  {
    title: 'Mais Valor',
    description:
      'Crie ofertas que resolvem as necessidades reais dos seus clientes, de forma prática e relevante.',
    imageUrl: '/images/jtbdpage/value.svg',
  },
  {
    title: 'Mais Diferenciação',
    description:
      'Destaque-se da concorrência ao mostrar que compreende os objetivos e motivações dos seus clientes.',
    imageUrl: '/images/jtbdpage/segment.svg',
  },
  {
    title: 'Comunicação Clara',
    description:
      'Fale diretamente do que importa para o seu cliente - com mensagens alinhadas ao benefício que ele procura alcançar.',
    imageUrl: '/images/jtbdpage/communication.svg',
  },
];

const JTBDMatter = () => {
  return (
    <section className="JTBDMatter section">
      <div className="wrapper wrapper--medium">
        <h2 className="wrapper__title wrapper centered">{jtbdSection.title}</h2>
        <h3 className="wrapper__subtitle h6 wrapper centered">{jtbdSection.subtitle}</h3>

        <div className="row col-4">
          {benefitsData.map((item, index) => (
            <div key={index} className="col card card--rounded card--no-shadow">
              <img alt="" className="card__icon" src={item.imageUrl} />
              <h3 className="card__title h4">{item.title}</h3>
              <div className="card__description centered">
                {item.description}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default JTBDMatter;